import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import Button from '../../components/Button';
import Modal from '../../components/Modal';
import Loader from '../../components/Loader';
import Dimmer from '../../components/Dimmer';
import Message from '../../components/Message';
import Form from '../../components/Form';
import Radio from '../../components/Radio';
import messages from './messages';

class OptInorOutRatingsModal extends React.PureComponent {
  static propTypes = {
    intl: PropTypes.object,
    displayNotification: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    heAccount: PropTypes.shape({
      id: PropTypes.object.isRequired,
      repVisitsSettings: PropTypes.object.isRequired,
    }).isRequired,
    optInorOutRatings: PropTypes.func.isRequired,
  };

  state = {
    isError: false,
    optedOutOfRepVisitsRatings: this.props.heAccount.repVisitsSettings.optedOutOfRepVisitsRatings,
    requesting: false,
  };

  handleChange = (e, { value }) => {
    this.setState({ optedOutOfRepVisitsRatings: value });
  };

  closeModal = () => {
    this.setState({ requesting: false });
    this.props.onClose();
  };

  updateOptInOrOutRatings = () => {
    const { displayNotification, optInorOutRatings } = this.props;
    const onFailure = () => {
      displayNotification(false, this.state.optedOutOfRepVisitsRatings);
      this.setState({ isError: true, requesting: false });
    };

    const onSuccess = () => {
      displayNotification(true, this.state.optedOutOfRepVisitsRatings);
      this.closeModal();
    };

    return optInorOutRatings({
      variables: {
        input: {
          repVisitsSettings: {
            optedOutOfRepVisitsRatings: this.state.optedOutOfRepVisitsRatings,
          },
        },
      },
    }).then(onSuccess).catch(onFailure);
  };

  render() {
    const { intl, open } = this.props;
    const { isError, requesting } = this.state;
    const errorDetails = isError ? (
      <Message role="alert" negative>
        <Message.Header><FormattedMessage {...messages.removeHeader} /></Message.Header>
      </Message>
    ) : '';

    return (
      <Dimmer.Dimmable as={Modal} open={open}>
        <Dimmer
          tabIndex={-1}
          role="progressbar"
          aria-describedby="Requesting to turn Visit Feedback requests on or off"
          aria-busy={requesting}
          inverted
          active={requesting}
        >
          <Loader active={requesting} />
        </Dimmer>
        <Modal.Header as="h2">
          <strong>
            <FormattedMessage
              {...messages.toggleModalHeader}
            />
          </strong>
        </Modal.Header>
        <Modal.Content>
          <div id="toggle-modal-message"><FormattedMessage {...messages.toggleModalMessage} /></div>
          <Form>
            <div role="group" aria-labelledby="toggle-modal-message">
              <Form.Field>
                <Radio
                  aria-label={intl.formatMessage(messages.yesToVisitFeedback)}
                  label={intl.formatMessage(messages.yesToVisitFeedback)}
                  name="radioGroup"
                  value={false}
                  checked={this.state.optedOutOfRepVisitsRatings === false}
                  onChange={this.handleChange}
                />
              </Form.Field>
              <Form.Field>
                <Radio
                  aria-label={intl.formatMessage(messages.noToVisitFeedback)}
                  label={intl.formatMessage(messages.noToVisitFeedback)}
                  name="radioGroup"
                  value
                  checked={this.state.optedOutOfRepVisitsRatings === true}
                  onChange={this.handleChange}
                />
              </Form.Field>
            </div>
          </Form>
          {errorDetails}
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.closeModal}>
            <FormattedMessage id="common.button.cancel" defaultMessage="Cancel" />
          </Button>
          <Button primary onClick={this.updateOptInOrOutRatings}>
            <FormattedMessage id="common.button.save" defaultMessage="Save" />
          </Button>
        </Modal.Actions>
      </Dimmer.Dimmable>
    );
  }
}

export default injectIntl(OptInorOutRatingsModal);
